import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";

const styles = {
  '& .diagonal': {
    backgroundImage: `linear-gradient(-60deg, #343434 50%, ${colors.black} 50%)`,
  },
  '& #gallery-title': {
    color: colors.white
  },
  '& #gallery-description': {
    color: colors.white
  }
};

const templateStyles: any = (theme?: Theme) => styles;

export default templateStyles;